import { createApp } from 'vue'
import App from './App.vue'
import { router } from './router'
import { AUTH_EXPIRED_EVENT } from '@/lib/api'
import { auth } from '@/stores/auth'
import './styles.css'

window.addEventListener(AUTH_EXPIRED_EVENT, () => {
  auth.expire()
  const current = router.currentRoute.value
  if (current.name === 'login') return
  void router.replace({ name: 'login', query: { redirect: current.fullPath } })
})

createApp(App).use(router).mount('#app')
